<style>
	.demo-ruleForm .el-form-item__content {
		display: flex; flex-direction: row;
		margin-left: 0!important;
	}
	.demo-ruleForm .el-input {
		width: 220px!important;
	}
</style>

<template>
	<div>
		<el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="比赛ID">
				<el-input size="small" v-model="ruleForm.match_id"></el-input>
			</el-form-item>
			
			<el-form-item label="场次:">
				<el-input size="small" v-model="ruleForm.issue_week"></el-input>
			</el-form-item>
			
			<el-form-item label="主队VS客队:">
				<el-input size="small" v-model="ruleForm.short_home"></el-input>
				<div style="width: 30px; text-align: center;">:</div>
				<el-input size="small" v-model="ruleForm.short_away"></el-input>
			</el-form-item>
			<el-form-item label="半场比分:">
				<el-input size="small" v-model="odds.home_half_score"></el-input>
				<div style="width: 30px; text-align: center;">:</div>
				<el-input size="small" v-model="odds.away_half_score"></el-input>
			</el-form-item>
			<el-form-item label="全场比分:">
				<el-input size="small" v-model="odds.home_score"></el-input>
				<div style="width: 30px; text-align: center;">:</div>
				<el-input size="small" v-model="odds.away_score"></el-input>
			</el-form-item>
			<el-form-item label="全场比分:">
				<el-input size="small" v-model="format.crs"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.crs}}</div>
			</el-form-item>
			
			<el-form-item label="胜平负:">
				<el-input size="small" v-model="format.had" style="width: 220px;"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.had}}</div>
			</el-form-item>
			
			<el-form-item label="让球胜平负:">
				<el-input size="small" v-model="format.hhad"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.hhad}}</div>
			</el-form-item>
			
			<el-form-item label="总进球:">
				<el-input size="small" v-model="format.ttg"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.ttg}}</div>
			</el-form-item>
			
			<el-form-item label="半全场:">
				<el-input size="small" v-model="format.hafu"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.hafu}}</div>
			</el-form-item>
			
			<el-form-item>
				<el-button type="success" @click="getMatchData()">获取数据</el-button>
				<el-button type="primary" @click="submitApi()">保存发布</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
		computed:{
			teamVS(){
				return this.ruleForm.short_home + ' VS ' + this.ruleForm.short_away;
			}
		},
	    data() {
			return {
				odds:{
					home_half_score:'',
					away_half_score:'',
					home_score:'',
					away_score:'',
					had:'',
					hhad:'',
					ttg:'',
					hafu:'',
					crs:'',
				},
				format:{
					half_score:'',
					crs:'',
					had:'',
					hhad:'',
					ttg:'',
					hafu:''
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			fotmatchMatchScore(_list){
				let _this = this;
				_list.forEach((row,key)=>{
					if(row.sectionNo == 1){
						let _exp = row.score.split(":");
						_this.odds.home_half_score = _exp[0];
						_this.odds.away_half_score = _exp[1];
					}
					if(row.sectionNo == 2){
						let _exp = row.score.split(":");
						_this.odds.home_score = _exp[0];
						_this.odds.away_score = _exp[1];
					}
				});
			},
			getedMatchResult(_result){
				console.log(_result);
				let _this = this;
				let _rs = '';
				let _rs1 = '';
				if(_result.length == 0){
					return _this.$message({
						 message: '未公布赛果',
						 type: 'warning',
					});
				}
				_result.forEach((row,key)=>{
					console.log(row, key);
					if(row.code == 'HAD'){
						_rs = row.combination == 'H' ? '3' : (row.combination == 'D' ? '1' : '0');
						_this.odds.had = _rs + ',' + row.odds;
						
						_rs = row.combination == 'H' ? '胜' : (row.combination == 'D' ? '平' : '负');
						_this.format.had = _rs + '@' + row.odds;
					}
					if(row.code == 'HHAD'){
						_rs = row.combination == 'H' ? '3' : (row.combination == 'D' ? '1' : '0');
						_this.odds.hhad = row.goalLine + ',' + _rs + ',' + row.odds;
						
						_rs = row.combination == 'H' ? '胜' : (row.combination == 'D' ? '平' : '负');
						_this.format.hhad = '(' +  row.goalLine + ') ' + _rs + '@' + row.odds;
					}
					if(row.code == 'CRS'){
						_this.odds.crs = row.combinationDesc  + ',' + row.odds;
						_this.format.crs = row.combinationDesc + '@' + row.odds;
					}
					if(row.code == 'TTG'){
						_this.odds.ttg = row.combination + ',' + row.odds;
						_this.format.ttg = row.combination + '球@' + row.odds;
					}
					if(row.code == 'HAFU'){
						let _hafu = row.combination.split(":");
						_rs = _hafu[0] == 'H' ? '3' : (_hafu[0] == 'D' ? '1' : '0');
						_rs1 = _hafu[1] == 'H' ? '3' : (_hafu[1] == 'D' ? '1' : '0');
						_this.odds.hafu = _rs + ',' + _rs1 + ',' + row.odds;
						_this.format.hafu = row.combinationDesc + '@' + row.odds;
					}
				})
				this.getMatchData2();
			},
			cancelMatchResult(){
				let _this = this;
				
				_this.odds.home_half_score = 0;
				_this.odds.away_half_score = 0;
				_this.odds.home_score = 0;
				_this.odds.away_score = 0;
				
				_this.format.had = '无效场次';
				_this.format.hhad = '无效场次';
				_this.format.crs = '无效场次';
				_this.format.hafu = '无效场次';
				_this.format.ttg = '无效场次';
				
				_this.odds.had = '*';
				_this.odds.hhad = '*';
				_this.odds.crs = '*';
				_this.odds.hafu = '*';
				_this.odds.ttg = '*';
			},
			getMatchData2(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '获取中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/Sporttery/getFootballScoreApi?matchId=" + _this.ruleForm.match_id, {baseURL:'http://122.228.193.118:8877'}).then(res=>{
					loading.close();
					if(res.success)
					{
						_this.fotmatchMatchScore(res.value.sectionsNos);
					}else{
						return _this.$message({
							 message: '获取数据失败，请重试（勿频繁点击）',
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			getMatchData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '获取中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/Sporttery/getFootballResultApi?matchId=" + _this.ruleForm.match_id, {baseURL:'http://122.228.193.118:8877'}).then(res=>{
					loading.close();
					if(res.success)
					{
						if(res.value.matchResultList.length != 0){
							_this.getedMatchResult(res.value.matchResultList);
						}else if(res.value.sectionsNo999 && res.value.sectionsNo999 == '无效场次'){
							// 比赛取消
							_this.cancelMatchResult();
						}else{
							return _this.$message({
								 message: '未公布赛果',
								 type: 'warning',
							});
						}
					}else{
						return _this.$message({
							 message: '获取数据失败，请重试（勿频繁点击）',
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '发布中..',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Open/saveFootballResult", {match_id: _this.ruleForm.match_id, ..._this.odds}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>